import axios from "axios";
const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;
export const http = axios.create({ baseURL: API });
http.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("mp_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});
